import styled, { css } from 'styled-components';

import { size } from '../../layout/helpers';
import { Link as StyledLink, RouterLink as StyledRouterLink } from '../Link';

export const List = styled.div.withConfig({ componentId: 'sc-nfnmc3-0' })`
    display: grid;
    grid-template-columns: repeat(var(--_columns, 2), minmax(0, 1fr));
    align-items: start;
    gap: ${size(2)};

    ${(props) => props.theme.breakpoint.Sm} {
        --_columns: 3;
    }

    ${(props) => props.theme.breakpoint.Md} {
        --_columns: 4;
    }
`;

const linkStyle = css`
    color: currentColor;
    font-size: var(--font-size-small-static);
`;

export const Link = styled(StyledLink).withConfig({ componentId: 'sc-nfnmc3-1' })`
    ${linkStyle};
`;

export const RouterLink = styled(StyledRouterLink).withConfig({ componentId: 'sc-nfnmc3-2' })`
    ${linkStyle};
`;

export const TextTail = styled.span.withConfig({ componentId: 'sc-nfnmc3-3' })`
    color: var(--c-text-muted);
`;
